import { useContext, useState } from "react";
import { AuthContext } from "../../utils/AuthContext";
import { getCard } from "../../api/optcgapi";
import CardsGallery from "../cards-gallery/cards-gallery";
import "./add-card-modal.css"

export default function AddCardModal ({  setModal, ownedCards = [], setUserInfo }) {

    const { authState } = useContext(AuthContext);

    const [cardData, setCardData] = useState(null);

    const handleSearchCard = (e, cardID) => {
        e.preventDefault();
        getCard(cardID).then((data) => {
            setCardData(data)
        })
    }

    return <div className="modal-overlay" onClick={() => setModal(false)}>
        <div className="add-card-modal" onClick={(e) => e.stopPropagation()}> 
            <form onSubmit={(e) => handleSearchCard(e, e.target[0].value)}>
                <input type="text" placeholder="Enter Card Code" />
                <input type="submit" value="Search" className="cta" />
            </form>
            
            {cardData && typeof cardData === "string" && <p>{cardData}</p>}
            {cardData && typeof cardData === "object" && <CardsGallery mode="all-cards" cards={cardData} ownedCards={ownedCards} setUserInfo={setUserInfo} />}

            {cardData && <div className="close-modal" onClick={() => setModal(false)}>
                <img src={`${process.env.PUBLIC_URL}/assets/304947.svg`} alt="close" height="30" width="30"/>
            </div>}
        </div>
    </div>
}